export enum SecEventCategory {
  Signal = 1,
  Graphics = 2,
  FloatingMedia = 3,
}
